import React from 'react';
import {
  Shirt,
  Footprints,
  Baby,
  Sun,
  Heart,
  Glasses,
  ShoppingBag,
  Gem,
  Dumbbell,
  Briefcase,
  Sparkle,
  Flower,
  Crown,
  Tag,
} from 'lucide-react';

// Map slug -> Lucide icon component. Falls back to Sparkle (curated) when unknown.
const ICONS = {
  'dameskleding': Shirt,
  'schoenen': Footprints,
  'kinderkleding': Baby,
  'badmode': Sun,
  'lingerie': Heart,
  'accessoires': Glasses,
  'tassen': ShoppingBag,
  'sieraden': Gem,
  'sportkleding': Dumbbell,
  'herenkleding': Briefcase,
  'verzorging': Sparkle,
  'parfum': Flower,
  'designer-collectie': Crown,
  'discount-outlet': Tag,
};

/**
 * Renders a Lucide line-icon for a category, in the brand's pink/purple tint by default.
 * Props:
 *   slug    — category slug (required)
 *   size    — icon size in px (default 32)
 *   stroke  — stroke width (default 1.5 for an elegant editorial feel)
 *   className — extra classes for the wrapping span (e.g. "text-white" to override color)
 */
const CategoryIcon = ({ slug, size = 32, stroke = 1.5, className = '' }) => {
  const Icon = ICONS[slug] || Sparkle;
  // Only apply the default pink color if no text-* class is supplied via className
  const hasColorOverride = /\btext-[a-z]+/.test(className);
  const colorClass = hasColorOverride ? '' : 'text-pink-500';
  return (
    <span className={`inline-flex items-center justify-center ${colorClass} ${className}`}>
      <Icon size={size} strokeWidth={stroke} />
    </span>
  );
};

export default CategoryIcon;
